'use client';

import type { FC } from 'react';
import { useEffect } from 'react';
import { useNavigation } from '../../contexts/NavigationContext';
import type { ScreenParams } from '../../types/navigation';

interface BattleHistoryScreenProps {
  params?: ScreenParams;
}

export const BattleHistoryScreen: FC<BattleHistoryScreenProps> = () => {
  const navigation = useNavigation();

  useEffect(() => {
    navigation.pushScreen('games', 'case-battles', { filter: 'history' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
